import {Component} from '@angular/core';
import {NavController,AlertController,ToastController,LoadingController,Events} from 'ionic-angular';
import {Settings} from '../../providers/settings';
import {CartManager} from '../../providers/cart-manager';
import {ChangePasswordPage} from '../change-password/change-password';
import {Theming} from "../../providers/data";
import {Constants} from '../../providers/config';
import { ImageLoader } from 'ionic-image-loader';
import { Storage } from '@ionic/storage';
import { Api } from '../../providers/api';
import { ApplicationVariables } from '../../providers/config';
import { ApiOffline } from '../../providers/api-offline';
import { MsgManager } from '../../providers/msg-manager';
import {GVLogger} from "../../services/gv-logger";


@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html'
})
export class SettingsPage {

  isOfflineMode:any = false;
  private theming = Theming;
  public constants = Constants;
	public staySignedIn: any;
	public stayAwake: any;
  public defaultView :string;
  negInv:boolean;
  cacheImages = false;
  isOffline = false;
  cacheImagesTag = "cacheImages";
  cacheCompletedTag = "";
  loader: any;
  cancel = false;

  cancelSpinnerDialogcount = 0 ;

  loadComplete = false;
  imagesLoadedCount = 0;
  requestComplete = true;
  lastDataUpdateDate = "";

  loaderControll:any;

  constructor(public nav: NavController,public settings:Settings,
  				public cartManager:CartManager,
          private storage:Storage,
          private imageLoader:ImageLoader,
          private alertCtrl:AlertController,
          private toastCtrl:ToastController,
          private api:Api,
          private loadingCtrl:LoadingController,
          private apiOffline:ApiOffline,
          private events:Events,
          private msgManager:MsgManager,
              private gVLogger: GVLogger) {

          this.cacheCompletedTag = "cacheCompleted"+this.cartManager.getADPCustomerUUID();

          this.storage.get("lastDataUpdateDate-"+this.cartManager.getADPCustomerUUID()).then((val)=>{
            this.lastDataUpdateDate = val;
          });



          this.events.subscribe("DATASYNCCOMPLETE",()=>{

             var today  = new Date().toJSON().slice(0,19);
             var str = today.split('T');
             var date = str[0];
             var time = str[1];

             this.storage.set("lastDataUpdateDate-"+this.cartManager.getADPCustomerUUID(),date+" "+time);
             this.lastDataUpdateDate = today;

          });


          this.gVLogger.log(this.constants);
  		this.staySignedIn = this.settings.getStaySignedIn();
  		this.gVLogger.log(this.staySignedIn);
      this.storage.get(this.cacheImagesTag).then((cache)=>{
        this.cacheImages = cache;
      });
      this.storage.get("defaultLayout").then((dv)=>{
        this.defaultView = dv;
      });
      this.storage.get("negativeInventory").then((nI)=>{
        this.negInv = nI;
      });

      this.storage.get("isOfflineMode").then((off)=>{
        this.isOffline = off;
      });
  }

  negativeInventory(){
  	this.storage.set("negativeInventory",this.negInv);
  }


  setStaySignedIn(){
    if(this.staySignedIn){
      this.setUserLocal();
    }else{
      this.removeUserLocal();
    }
    this.settings.setStaySignedIn(this.staySignedIn);
    this.gVLogger.log(this.staySignedIn);
  }

  changeDefaultView(){
    this.setDefaultLayout(this.defaultView);
  }

  setStayAwake(){
  	if(this.stayAwake){
  		// TODO: Stay Awake Logic Goes Here
  	}else{
  		// TODO: Stay Awake Logic Goes Here
  	}
  	this.settings.setStayAwake(this.stayAwake);
  	this.gVLogger.log(this.stayAwake);
  }


  setUserLocal(){
    this.storage.set("user",this.cartManager.getSalesPerson());
  	//localStorage.setItem("user",JSON.stringify(this.cartManager.getSalesPerson()));
  	this.gVLogger.log(localStorage.getItem("user"));
  }
  removeUserLocal(){
    this.storage.remove("user");
  	//localStorage.removeItem("user");
  }

  setDefaultLayout(layout){
    this.gVLogger.log("Layout change");
    this.storage.set("defaultLayout",layout);
   }


  gotoChangePassword(){

    this.nav.push(ChangePasswordPage);

  }


  changeColor(color){
    Theming.selected = color;
  }

  clearImagesCache(){

    let alert = this.alertCtrl.create({
    title: 'Are you sure?',
    message: 'Do you want to clear images cache?',
    buttons: [
      {
        text: 'Cancel',
        role: 'cancel',
        handler: () => {
          this.gVLogger.log('Cancel clicked');
        }
      },
      {
        text: 'Clear Cache',
        handler: () => {
          this.settings.imagesLoadedCount = 0;
          this.storage.set("cacheCompleted",false);
          this.imageLoader.clearCache();
          this.gVLogger.log("images cache cleaned");
        }
      }
    ]
  });
  alert.present();

  }

   preLoadImages(){
     this.storage.set(this.cacheCompletedTag,false);
     this.settings.preLoadImages();
  }

  cacheImagesChanged(){

      let cancelTemp = false;

      if(!this.cacheImages){
          let alert = this.alertCtrl.create({
          title: 'Are you sure?',
          message: 'Do you want to clear images cache?',
          buttons: [
            {
              text: 'Cancel',
              role: 'cancel',
              handler: () => {
                this.gVLogger.log('Cancel clicked');

                this.cacheImages = true;
                cancelTemp = true;
              }
            },
            {
              text: 'Clear Cache',
              handler: () => {
                this.settings.imagesLoadedCount = 0;
                this.storage.set(this.cacheImagesTag,this.cacheImages);
                this.storage.set(this.cacheCompletedTag,false);
                this.imageLoader.clearCache();
                this.gVLogger.log("images cache cleaned");
              }
            }
          ]
        });
        alert.present();
      }else if(this.cacheImages){
        this.storage.set(this.cacheImagesTag,this.cacheImages);
        this.storage.get(this.cacheCompletedTag).then((cacheCompleted)=>{
          if(!cacheCompleted){
           this.settings.preLoadImages();
          }
        });
        }

  }


  toggleOfflineMode(){
    ApplicationVariables.isOffline = this.isOffline;
    this.storage.set("isOfflineMode",this.isOffline);
    this.events.publish("ModeChanged");
  }



  syncDataFromServer(){


    // delete all data in DB

    this.apiOffline.deleteOfflineData().then(res=>{
      this.apiOffline.syncCustomersFromCloud(0).then((res)=>{

        // alert("Completed");
      },(err)=>{

        // alert("Completed with error");
      });
    },err=>{

      let t =  this.toastCtrl.create({
             message:"Error deleting data.",
             duration:3000,
             position: 'bottom'
             });
           t.present();

    })

  }

  showAllData(){
    this.apiOffline.getAllProducts();
  }


  syncOrders(){

    this.apiOffline.isInternetConnected().then((success)=>{
      this.apiOffline.syncOrdersToServer();
    },(err)=>{
      this.msgManager.toastMsg("Connected, no internet");
      //  let t =  this.toastCtrl.create({
      //              message:"Connected, no internet",
      //              duration:3000,
      //              position: 'bottom'
      //              });
      //            t.present();

    })

  }


}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts